export default __webpack_public_path__ + "static/media/transfer.762b9e23.svg";